import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=ec6d6ce2&scoped=true&"
import script from "./AppDrawer.vue?vue&type=script&lang=js&"
export * from "./AppDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6d6ce2",
  null
  
)

export default component.exports